import gql from 'graphql-tag'

/**
 * Mutation to create a new vehicle record within a vehicle list.
 * Requires vehicleListId, captureTimestamp, and plateText at minimum.
 */
export const CREATE_VEHICLE_RECORD_M = gql`
  mutation CreateVehicleRecord(
    $vehicleListId: Int!
    $captureTimestamp: String!
    $plateText: String!
    $brand: String
    $model: String
    $type: String
  ) {
    createVehicleRecord(
      createVehicleRecordInput: {
        vehicleListId: $vehicleListId
        captureTimestamp: $captureTimestamp
        plateText: $plateText
        brand: $brand
        model: $model
        type: $type
      }
    ) {
      code
      success
      message
      vehicleRecord {
        id
        vehicleListId
        captureTimestamp
        plateText
        brand
        model
        type
        createdAt
      }
    }
  }
`

/**
 * Mutation to update an existing vehicle record.
 * Only the id is required; all other fields are optional.
 */
export const UPDATE_VEHICLE_RECORD_M = gql`
  mutation UpdateVehicleRecord(
    $id: Int!
    $captureTimestamp: String
    $plateText: String
    $brand: String
    $model: String
    $type: String
  ) {
    updateVehicleRecord(
      updateVehicleRecordInput: {
        id: $id
        captureTimestamp: $captureTimestamp
        plateText: $plateText
        brand: $brand
        model: $model
        type: $type
      }
    ) {
      code
      success
      message
      vehicleRecord {
        id
        vehicleListId
        captureTimestamp
        plateText
        brand
        model
        type
        createdAt
      }
    }
  }
`

/**
 * Mutation to delete a vehicle record by its id.
 */
export const DELETE_VEHICLE_RECORD_M = gql`
  mutation DeleteVehicleRecord($id: Int!) {
    deleteVehicleRecord(id: $id) {
      code
      success
      message
    }
  }
`
